var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('b-icon',{attrs:{"variant":_vm.iconClass,"icon":"chat-right-text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }